/* eslint-disable react/jsx-props-no-spreading */
/**
 *
 * Button.react.js
 *
 * A common button, if you pass it a prop "route" it'll render a link to a react-router route
 * otherwise it'll render a link with an onclick
 */

import React from 'react'
import PropTypes from 'prop-types'

import StyledButton from './StyledButton'
import A from './A'

const Button = (props) => {
  const { children, href } = props
  if (href) {
    return <A {...props}>{children}</A>
  }
  return <StyledButton {...props}>{children}</StyledButton>
}

Button.defaultProps = {
  href: null,
}
Button.propTypes = {
  children: PropTypes.element.isRequired,
  href: PropTypes.string,
}

export default Button
